import { render, staticRenderFns } from "./Tiers.vue?vue&type=template&id=e0709992&scoped=true"
import script from "./Tiers.vue?vue&type=script&lang=js"
export * from "./Tiers.vue?vue&type=script&lang=js"
import style0 from "./Tiers.vue?vue&type=style&index=0&id=e0709992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0709992",
  null
  
)

export default component.exports